module.exports = __webpack_public_path__ + "static/media/img-interface-es.73f7e2b1.png";